import { render, staticRenderFns } from "./Hosting.vue?vue&type=template&id=328141b8&"
import script from "./Hosting.vue?vue&type=script&lang=js&"
export * from "./Hosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports